import styles from './styles.module.scss';
const { checkbox, checkbox_label, header } = styles;

type optionsType = {
  label: string;
  value?: string;
};

type Props = {
  label?: string;
  inputName?: string;
  options: optionsType[];
  register: ReturnType<typeof import('react-hook-form').useForm>['register'];
  required?: boolean;
};

const CheckboxGroup = ({ label, inputName, options, register, required = false }: Props) => {
  const fieldName = inputName || label;

  return (
    <div>
      {label && <span className={header}>{label}</span>}
      {options.map((option, idx) => (
        <label key={idx} className={checkbox_label}>
          <input
            className={checkbox}
            type="checkbox"
            value={option.value ?? option.label}
            {...register(fieldName, {
              validate: required
                ? () => {
                    // Get all checked checkboxes with this name
                    const checkboxes = document.querySelectorAll(
                      `input[name="${fieldName}"]:checked`
                    );
                    return checkboxes.length > 0 || 'Please select at least one option';
                  }
                : undefined
            })}
          />
          {option.label}
        </label>
      ))}
    </div>
  );
};

export default CheckboxGroup;
